import _Api from '@/api/_Api';

export interface FindGroupByRefParams {
   q: string | number;
   archive?: boolean;
}

export interface FindGroupByRefItemResponse {
   readonly o_id: number;
   readonly o_name?: string;
   readonly o_lead_guest?: string;
}

export interface FindGroupByRefResponse {
   [key: string]: FindGroupByRefItemResponse[];
}

export class SearchApi extends _Api {
   static async findGroupByRef(params: FindGroupByRefParams): Promise<FindGroupByRefResponse> {
      const response = await this.http().get('search/find-group-by-ref', { params });
      return response.data;
   }

   static async findActivity(params: FindGroupByRefParams): Promise<FindGroupByRefResponse> {
      const response = await this.http().get('search/find-activity', { params });
      return response.data;
   }
}
